const flags = {
  APP_MODERNISATION: "APP_MODERNISATION",
  WEB_MODERNISATION: "WEB_MODERNISATION",
  FORCE_APP_MODE: "FORCE_APP_MODE",
  ENHANCED_SEARCH: "ENHANCED_SEARCH",
  B2C_DISABLE_AUTH: "B2C_DISABLE_AUTH",
  ENHANCED_COUNTER: "ENHANCED_COUNTER",
  ENHANCED_BROWSER_HISTORY_BUTTON: "ENHANCED_BROWSER_HISTORY_BUTTON",
  CALCULATORS_LEGACY_INTEGRATION: "CALCULATORS_LEGACY_INTEGRATION",
  AIDH_ENABLED: "AIDH_ENABLED",
  DRTC_ENABLED: "DRTC_ENABLED",
  OBESITY_ENABLED: "OBESITY_ENABLED",
  ADPHA_B2C_PROMOTION: "ADPHA_B2C_PROMOTION",
  // salesforce integration flags
  SALESFORCE_ENABLED: "salesforce_enabled",
  SUBSCRIBE_ENABLED: "subscribe_enabled",
  PORTAL_ENABLED: "portal_enabled",
  UPDATED_EXPERT_GROUPS: "UPDATED_EXPERT_GROUPS",
};

export const FLAGSMITH_API_URL = "https://edge.api.flagsmith.com/api/v1/flags/";

export default Object.freeze(flags);
